import React from 'react';
import { cdnImage } from '@/utils/image-utils';
import { Button } from '@/components/buttons/Button';
import { useIntl } from 'react-intl';
import { BffIdScanStatusStatus } from '@lucky7ventures/bff-types';

interface IdScanFinishedProps {
  ctaOnClick?: () => void;
  status?: BffIdScanStatusStatus | null;
  rejectedOnClick: () => void;
  approvedOnClick: () => void;
}

const IdScanFinished = ({
  ctaOnClick,
  status,
  rejectedOnClick,
  approvedOnClick,
}: IdScanFinishedProps) => {
  const isRejected = status === BffIdScanStatusStatus.Rejected;
  const isExpired = status === BffIdScanStatusStatus.Expired;
  const isApproved = status === BffIdScanStatusStatus.Approved;
  const titleMessageId = isRejected
    ? 'id-scan-modal.finished-rejected-title'
    : 'id-scan-modal.finished-approved-title';
  const descriptionMessageId = isRejected
    ? 'id-scan-modal.finished-rejected'
    : isExpired
    ? 'id-scan-modal.finished-expired'
    : 'id-scan-modal.finished-approved';

  const intl = useIntl();
  return (
    <div className="flex flex-col items-center text-center gap-y-4">
      <img
        src={cdnImage('sitting-cat.png', {
          width: '160',
          height: '160',
          fit: 'scale-down',
        })}
        alt="Lucky Cat"
      />
      <h3 data-cy="id-scan-finished-text">
        {intl.formatMessage({
          id: titleMessageId,
        })}
      </h3>
      <p>
        {intl.formatMessage({
          id: descriptionMessageId,
        })}
      </p>
      {isApproved && (
        <>
          <p className="font-bold">
            {intl.formatMessage({
              id: 'id-scan-modal.welcome-offer-text',
            })}
          </p>
          <Button
            onClickHandler={approvedOnClick}
            text={intl.formatMessage({ id: 'id-scan-modal.welcome-offer-button' })}
          />
        </>
      )}

      {isRejected && (
        <Button
          text={intl.formatMessage({ id: 'login.contactSupport' })}
          onClickHandler={rejectedOnClick}
        />
      )}
      {isExpired && (
        <Button
          text={intl.formatMessage({ id: 'id-scan-modal.request-new-id-scan' })}
          onClickHandler={ctaOnClick}
        />
      )}
    </div>
  );
};

export default IdScanFinished;
